import React from 'react';
import Flagship from '../../core/flagship';
import {Link} from 'react-router';
import { Button, Feed, Loader, Segment, Icon, Label } from 'semantic-ui-react';

class NewIos extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
    }

    getInitialState() {
        return {
            offset: 0,
            items: [],
            error: '',
            loading: false
        }
    }

    componentDidMount() {
        this.getFeedItems();
    }

    componentWillUnmount() {
        this.interval = null;
    }

    getFeedItems() {
        this.setState({
            loading:true
        });

        let self = this;

        Flagship.get(
            'recent-records/io/',
            {},
            function(response) {

                if (response.data.success === true ) {
                    self.setState(
                        {
                            items:  response.data.results,
                            loading: false

                        });
                } else {
                    self.setState(
                        {
                            error: "Failed to load new IOs.",
                            loading: false
                        }
                    );
                }
            }
        );
    }


    getMessage(action) {
        if ( Flagship.config.possibleActions.hasOwnProperty(action) ) {
            return Flagship.config.possibleActions[action]
        }
        return '';
    }


    render() {

        let recordTypeConfig = Flagship.config.records["io"];

        return (
            <div className="fade-in">
                <Feed>
                    {this.state.error !== '' ? this.state.error : ''}

                    {typeof this.state.items !== "undefined" && this.state.items.length > 0 ? this.state.items.map(function(item, i) {

                       return (
                           <Feed.Event key={"feed-item-" + i}>
                               <Feed.Content>
                                   <Feed.Extra text>
                                       <Link className="single-dash-widget-record" to={'/' + item.record_type + '/view/' + item.record_key}>
                                       <Segment>
                                           <h3>
                                               <Icon className="feed-icon" disabled size="large" color="grey" name="dollar" />
                                               {'#' + item.record_key + ' - ' + item.record_name}
                                           </h3>
                                           <Label color={recordTypeConfig.statuses[item.record_status].color}>{recordTypeConfig.statuses[item.record_status].label}</Label>
                                           {item.extra3 !== "" && typeof item.extra3 !== "undefined" ?
                                               <div style={{marginTop: "1em"}}>
                                                <Icon name="lab" color="grey" />
                                                <em>Market Contact: {item.extra3}</em>
                                               </div>
                                               : null}
                                       </Segment>
                                       </Link>
                                   </Feed.Extra>
                               </Feed.Content>
                           </Feed.Event>
                       )
                    }) : <div className="white-text">No upcoming IOs found.</div>}
                </Feed>
                <Link to="/ios?status=publish">
                    <Button className="view-all-button" icon="caret right" content="View all upcoming IOs" />
                </Link>

                <span>&nbsp;</span>&nbsp;
                {this.state.loading === true ? <Loader className="flagship-loader" active={this.state.loading} inline /> : null }
            </div>
        );
    }
}
export default NewIos;





// WEBPACK FOOTER //
// ./src/components/dashboard/NewIos.js